import { toast } from "react-toastify";
import { ALERT_TIME_OUT } from "../constants";

export const notifySuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: ALERT_TIME_OUT,
    theme: "colored",
    hideProgressBar: true,
  });
};

export const notifyError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: ALERT_TIME_OUT,
    theme: "colored",
    hideProgressBar: true,
  });
};